<script lang="ts">

  import { cType, hourlyForecast, dailyForecast, ForecastType, Forecast } from "../store";
  import { WeatherIcon } from "../weather_code";

  export let forecastType: ForecastType = ForecastType.HOURLY;
  export let conditionType: cType = cType.TEMP;

  let dailyData: Array<Forecast> = [];
  let hourlyData: Array<Forecast> = [];

  let weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  hourlyForecast.subscribe((value: Array<Forecast>) => {
    if (value) hourlyData = value.slice(1, 4);
  });

  dailyForecast.subscribe((value: Array<Forecast>) => {
    if (value) dailyData = value.slice(1, 4);
  });

  function getConditionValue(forecast: Forecast) {
    switch (conditionType) {
      case cType.WBGT:
        return `${forecast.wgbt.value.toFixed(0)}`;
      case cType.WIND:
        return `${forecast.windSpeed.value.toFixed(0)}`;
      case cType.PRECIP:
        return `${forecast.precipitationChance.value.toFixed(0)}`;
      case cType.GUST:
        if(forecast.windGust != null){
          return `${forecast.windGust.value.toFixed(0)}`;
        }
        return `--`;
      case cType.FEEL:
        return `${forecast.feelLike.value.toFixed(0)}`;
      default:
      case cType.TEMP:
        return `${forecast.ambientTemperature.value.toFixed(0)}`;
    }
  }

  function getConditionUnit(forecast: Forecast) {
    switch (conditionType) {
      case cType.WIND:
      case cType.GUST:
        return `<span style='font-size: 50%;'>${forecast.windSpeed.unit.toLowerCase()}</span>`;
      case cType.PRECIP:
        return `${forecast.precipitationChance.unit}`;
      default:
      case cType.TEMP:
      case cType.WBGT:
      case cType.FEEL:
        return "&deg;";
    }
  }
  
</script>


  <div class="pw-flex forecast-container pw-justify-around" style="width: 100%; height: 100%;">
    {#if forecastType === ForecastType.DAILY}
      {#each dailyData as forecast}
        <div class="pw-flex-column pw-align-center pw-justify-between" style="color: var(--default-color);">
            <div class="label">
              {weekday[new Date(forecast.observationTime).getDay()]}
            </div>
              <img
                src={WeatherIcon(forecast.weather_code.value)}
                alt={forecast.weather_code.value}
                class="weatherIcon"
              />
             <div class="value">
                <span>{getConditionValue(forecast)}{@html getConditionUnit(forecast)}</span>
              </div>

            
            {#if conditionType === cType.WBGT}
              <div class="label">
                  WBGT
              </div>
            {/if}
        </div>
      {/each}
    {:else}
      {#each hourlyData as forecast}
        <div class="pw-flex-column pw-align-center pw-justify-around" style="color: var(--default-color);">
              
              <div class="label">
                {new Date(forecast.observationTime).toLocaleTimeString(
                  "en-US",
                  { hour: "numeric", hour12: true }
                )}
              </div>
              

              <img
                src={WeatherIcon(forecast.weather_code.value, new Date(forecast.observationTime))}
                alt={forecast.weather_code.value}
                class="weatherIcon"
              />


              <div class="value">
                <span>{getConditionValue(forecast)}{@html getConditionUnit(forecast)}</span>
              </div>
              

            {#if conditionType === cType.WBGT}
              <div class="label">
                  WBGT
              </div>
            {/if}

        </div>
      {/each}
    {/if}
  </div>


<style>

  /* @media(min-width: 1920px){
    .forecast-container{
      font-size: 25px;
    }
  }

  @media(min-width:3840px){
    .forecast-container{
      font-size: 50px;
    }
  } */
</style>
